import CodeBlock from "@tiptap/extension-code-block";
import { Document } from "@tiptap/extension-document";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Link from "@tiptap/extension-link";
import RTEOrderedList from "@tiptap/extension-ordered-list";
import Strike from "@tiptap/extension-strike";
import Underline from "@tiptap/extension-underline";
import { Content, Editor, useEditor as useTiptapEditor } from "@tiptap/react";

import ContentDrawerGroup from "@/view/TiptapArticleBody/extensions/ContentDrawerGroup/ContentDrawerGroup";
import { Core } from "@/view/TiptapArticleBody/extensions/core";
import GraphicOrganizerLink from "@/view/TiptapArticleBody/extensions/GraphicOrganizerLink";
import { HardBreakBlock } from "@/view/TiptapArticleBody/extensions/HardBreakBlock";
import HeadingBlock from "@/view/TiptapArticleBody/extensions/HeadingBlock";
import IgnoreBlock from "@/view/TiptapArticleBody/extensions/IgnoreBlock";
import { Image } from "@/view/TiptapArticleBody/extensions/Image";
import { Language } from "@/view/TiptapArticleBody/extensions/Language";
import {
  OrderedList,
  OrderedListItem,
  UnorderedList,
  UnorderedListItem,
} from "@/view/TiptapArticleBody/extensions/List";
import ParagraphBlock from "@/view/TiptapArticleBody/extensions/ParagraphBlock";
import PreformattedBlock from "@/view/TiptapArticleBody/extensions/PreformattedBlock";
import QuoteBlock from "@/view/TiptapArticleBody/extensions/QuoteBlock";
import {
  INodeAttrs,
  INodeBase,
} from "@/view/TiptapArticleBody/TiptapArticleBody.interface";

export interface ILessonPlanNode extends INodeBase {
  attrs?: INodeAttrs;
  content?: Content;
}

export interface IUseLessonPlanEditorProps {
  content: Content;
}

const useLessonPlanEditor = ({
  content,
}: IUseLessonPlanEditorProps): Editor | null => {
  const config = {
    editorProps: {
      attributes: {
        class: "lesson-plan-content",
        "data-testid": "lesson-plan-editor",
      },
    },
    extensions: [
      Core,
      ContentDrawerGroup,
      Document,
      HeadingBlock,
      Link,
      Image,
      Language,
      GraphicOrganizerLink,
      ParagraphBlock,
      HardBreakBlock,
      PreformattedBlock,
      QuoteBlock,
      IgnoreBlock,
      OrderedList,
      /* RTEOrderedList extensions allows Ordered Lists from the Rich Text Editor to be displayed properly */
      RTEOrderedList,
      OrderedListItem,
      UnorderedList,
      UnorderedListItem,
      HorizontalRule,
      Strike,
      CodeBlock,
      Underline,
    ],
    content,
    editable: false,
  };

  return useTiptapEditor(config, [content]);
};

export default useLessonPlanEditor;
